import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetCustomerRestaurantCompletedOrdersSlice = createSlice({
    name: "getCustomerRestaurantCompletedOrders",
    initialState,
    reducers: {
        getCustomerRestaurantCompletedOrdersRequest(state) {
            state.loading = true;
        },
        getCustomerRestaurantCompletedOrdersRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getCustomerRestaurantCompletedOrdersRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getCustomerRestaurantCompletedOrdersRequest,
    getCustomerRestaurantCompletedOrdersRequestSuccess,
    getCustomerRestaurantCompletedOrdersRequestError,
} = GetCustomerRestaurantCompletedOrdersSlice.actions;

export default GetCustomerRestaurantCompletedOrdersSlice.reducer;
